import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.workspace.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-workspace-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.workspace.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabWorkspaceListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 24;
    public text: string = '';
    public statusFilter: string = 'active';
    public favoriteOnly: boolean = false;
    public loaded: boolean = false;

    public showCreate: boolean = false;
    public newWs: any = { name: '', description: '', visibility: 'private', color: 'rose' };
    public colors: string[] = ['rose', 'blue', 'emerald', 'violet', 'amber'];

    public async ngOnInit() {
        await this.service.init();
        await this.search();
    }

    public async search(reset: boolean = true) {
        if (reset) this.page = 1;
        const res = await wiz.call("search", {
            page: this.page, dump: this.dump,
            text: this.text, status: this.statusFilter,
            favorite: this.favoriteOnly ? '1' : '',
        });
        if (res.code === 200) {
            this.rows = res.data.rows || [];
            this.total = res.data.total || 0;
        }
        this.loaded = true;
        await this.service.render();
    }

    public open(ws: any) {
        this.service.href(`/admin/collab/workspace/${ws.id}`);
    }

    public async toggleFavorite(ws: any, ev: Event) {
        ev.stopPropagation();
        const res = await wiz.call("toggle_favorite", { id: ws.id });
        if (res.code === 200) {
            ws.favorite = res.data.favorite;
            await this.service.render();
        }
    }

    public async create() {
        if (!this.newWs.name || !this.newWs.name.trim()) {
            this.service.alert.error("이름을 입력하세요.");
            return;
        }
        const res = await wiz.call("create", this.newWs);
        if (res.code === 200) {
            this.showCreate = false;
            this.newWs = { name: '', description: '', visibility: 'private', color: 'rose' };
            this.service.href(`/admin/collab/workspace/${res.data.id}`);
        } else {
            this.service.alert.error(res.data?.message || "생성 실패");
            await this.service.render();
        }
    }

    public openCreate() {
        this.showCreate = true;
        this.newWs = { name: '', description: '', visibility: 'private', color: 'rose' };
    }

    public closeCreate() {
        this.showCreate = false;
    }
}

export default PortalLpsysadminCollabWorkspaceListComponent;